// BOOST AI
(function () {
  // ---- CONFIG ----
  var ROOT_ID = 'boost-sd__filter-tree-wrapper';
  var MOBILE_ROOT_SELECTOR = '.boost-sd__filter-tree-vertical-sticky-overlay';
  var TITLE_SELECTOR = '.boost-sd__filter-option-title';
  var LABEL_SELECTOR = '.boost-sd__filter-option-item-label';
  var REFINE_HEADING_SELECTOR = '.boost-sd__refine-by-vertical-refine-by-heading';
  var REFINE_OPTION_SELECTOR = '.boost-sd__refine-by-vertical-refine-by-option';
  var TEXT_SELECTOR = [
    TITLE_SELECTOR,
    LABEL_SELECTOR,
    REFINE_HEADING_SELECTOR,
    REFINE_OPTION_SELECTOR
  ].join(',');

  // Translate only when UI is NOT Polish
  if (window.__IS_PL_LANGUAGE__) {
    return;
  }

  // ---- DICTIONARY ----
  var T = {
    // Section headers
    'Zainteresowania': 'Hobbies',
    'Styl graficzny': 'Graphic style',
    'Kolorystyka': 'Color scheme',
    'Rozmiar': 'Size',
    'Produkt': 'Product',
    'Produkty': 'Products',
    'Gry': 'Games',
    'Gry:': 'Games:',
    'Artyści': 'Artists',

    // Option values
    'anime': 'anime',
    'Anime': 'Anime',
    'natura': 'nature',
    'Natura': 'Nature',
    'średniowieczne fantasy': 'medieval fantasy',
    'zabawne': 'funny',
    'Zabawne': 'Funny',
    'Lochy': 'Dungeons',
    'minimalistyczne': 'minimalist',
    'retro': 'retro',
    'Retro': 'Retro',
    'pixelart': 'pixel art',
    'abstrakcja': 'abstract',
    'ilustracja': 'illustration',
    'Ilustracja': 'Illustration',
    '3D': '3D',
    'Produkt': 'Product',
    'Podkładki pod mysz': 'Mouse pads',
    'militarne': 'military',
    'Militaria': 'Military',
    'militaria': 'military',
    'motoryzacja': 'automotive',
    'scifi': 'sci-fi',
    'art': 'art',
    'Sztuka': 'Art',
    'sztuka': 'art',
    'Akcesoria': 'Accessories',
    'Odzież': 'Clothing',
    'odzież': 'Clothing',
    'Bluzy': 'Hoodies',
    'T-shirty': 'T-shirts',
    'Worko-Plecak': 'Drawstring bags',
    'Workoplecaki': 'Drawstring bags',
    'Worko-Plecaki': 'Drawstring bags',
    'Maty podłogowe': 'Floor mats',
    'Maty podlogowe': 'Floor mats',
    'Maty do gier': 'Gaming mats',
    'Etui do telefonu': 'Phone cases',
    'Etui do telefonów': 'Phone cases',
    'Szaliki': 'Scarves',
    'Maty do gier RPG': 'RPG mats',
    'Maty do RPG': 'RPG mats',
    // Compatibility with filter trees that still use the previous label.
    'Maty do gier bitewnych': 'RPG mats',
    'Maty do gier karcianych': 'Card game mats',
    'Karta podarunkowa': 'Gift card',
    'Minimalizm': 'Minimalism',
    'Piny': 'Pins',
    'Grafika 3D': '3D graphics',
    'Płyty Winylowe': 'Vinyl records',
    'Plyty Winylowe': 'Vinyl records'
  };

  var LOG_MISSING = true;
  var missing = Object.create(null);

  // Build a case-insensitive regex that matches any dictionary key as a whole word
  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  // Match full labels before shared prefixes such as 'Maty do gier'.
  var keysByLength = Object.keys(T).sort(function (a, b) { return b.length - a.length; });
  var KEY_RE = new RegExp('\\b(' + keysByLength.map(esc).join('|') + ')\\b', 'gi');

  function splitLabelAndCount(text) {
    var m = String(text || '').trim().match(/^(.+?)(\s*\(\d+\))?$/);
    return m ? { label: m[1].trim(), count: m[2] || '' } : { label: text, count: '' };
  }

  function lookup(src) {
    if (!src) return null;
    var direct = T[src];
    if (direct) return direct;
    var lower = src.toLowerCase();
    for (var k in T) if (k.toLowerCase() === lower) return T[k];
    return null;
  }

  // Replace only the first text node of an element (preserving icons, children)
  function setFirstTextNode(el, text) {
    var tn = null;
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3) { tn = n; break; }
    }
    if (tn) tn.nodeValue = text;
    else el.insertBefore(document.createTextNode(text), el.firstChild);
  }

  function currentLangKey() {
    // NIE zmieniamy sposobu detekcji języka – opieramy się wyłącznie na __IS_PL_LANGUAGE__
    return window.__IS_PL_LANGUAGE__ ? 'pl' : 'en';
  }

  function translateVisible(el) {
    if (!el) return;

    // Guard live: jeśli przełączyłeś na PL bez pełnego reloadu, nic nie tłumaczymy
    if (window.__IS_PL_LANGUAGE__) {
      // ale zostawmy ślad w logach, żeby było jasne
      if (el === document.querySelector(TITLE_SELECTOR) || el === document.querySelector(LABEL_SELECTOR)) {
        // ograniczenie hałasu w konsoli
      }
      return;
    }

    var LANG_KEY = currentLangKey();

    // jeśli element był cache'owany dla innego języka – wyczyść cache na nim
    if (el.dataset && el.dataset.boostTranslatedLang && el.dataset.boostTranslatedLang !== LANG_KEY) {
      delete el.dataset.boostTranslated;
      delete el.dataset.boostTranslatedLang;
    }

    var raw = (el.textContent || '').trim();
    if (!raw) return;

    var parts = splitLabelAndCount(raw);
    var mapped = lookup(parts.label); // istnieje -> mamy tłumaczenie PL->EN

    // ZAWSZE próbujemy tłumaczyć; cache nie blokuje działania
    if (mapped) {
      var finalText = mapped + parts.count;
      if (el.matches && el.matches(TITLE_SELECTOR + ',' + REFINE_HEADING_SELECTOR)) {
        setFirstTextNode(el, finalText);
      } else {
        el.textContent = finalText;
      }
      if (el.dataset) {
        el.dataset.boostTranslated = '1';
        el.dataset.boostTranslatedLang = LANG_KEY;
      }
    } else {
      // brak mapowania – nie blokujemy kolejnych prób; tylko log i zapamiętanie języka
      if (LOG_MISSING && !missing[parts.label]) {
        missing[parts.label] = 1;
      }
      if (el.dataset) {
        el.dataset.boostTranslatedLang = LANG_KEY;
      }
    }
  }

  function translateAria(target) {
    if (!target || !target.getAttribute) return;
    if (window.__IS_PL_LANGUAGE__) return; // guard live
    var v = target.getAttribute('aria-label');
    if (!v) return;
    var translated = v.replace(KEY_RE, function (match) {
      var m = lookup(match);
      return m || match;
    });
    if (translated !== v) {
      target.setAttribute('aria-label', translated);
    }
  }

  function translateIn(root) {
    if (!root || !root.querySelectorAll) return;
    if (window.__IS_PL_LANGUAGE__) {
      // tryb PL – nic nie ruszamy, ale logujemy 1x per wywołanie
      return;
    }
    var nodes = root.querySelectorAll(TEXT_SELECTOR);
    nodes.forEach(translateVisible);

    // Keep aria-labels consistent so Boost won't re-inject Polish
    root.querySelectorAll(TITLE_SELECTOR + ', .boost-sd__filter-option-item-button').forEach(translateAria);
  }

  var currentRoot = null;
  var currentMobileRoot = null;
  var mo = null;
  var mobileMo = null;

  function createObserver(root) {
    translateIn(root); // initial pass

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        if (m.type === 'childList') {
          // debug
          if ((m.addedNodes && m.addedNodes.length) || (m.removedNodes && m.removedNodes.length)) {
          }
          m.addedNodes && m.addedNodes.forEach(function (n) {
            if (n.nodeType === 1) translateIn(n);
          });
        } else if (m.type === 'characterData') {
          var host = m.target.parentElement || m.target;
          translateVisible(host);
        } else if (m.type === 'attributes' && m.attributeName === 'aria-label') {
          translateAria(m.target);
          if (m.target.matches(TEXT_SELECTOR)) translateVisible(m.target);
        }
      }
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-label']
    });

    return observer;
  }

  function observe(root) {
    if (!root) return;
    currentRoot = root;

    // disconnect poprzedni obserwator jeśli był
    if (mo) {
      try { mo.disconnect(); } catch(e){}
    }

    mo = createObserver(root);
  }

  function observeMobile(root) {
    if (!root) return;
    currentMobileRoot = root;

    if (mobileMo) {
      try { mobileMo.disconnect(); } catch(e){}
    }

    mobileMo = createObserver(root);
  }

  // Watchdog: jeśli Boost/Motion podmieni wrapper desktopowy lub mobilny,
  // podpinamy właściwy, zawężony obserwator ponownie.
  var rebindMo = null;
  function startRebindWatchdog() {
    if (rebindMo) return;
    rebindMo = new MutationObserver(function () {
      var r = document.getElementById(ROOT_ID);
      if (r && r !== currentRoot) {
        observe(r);
      }

      var mobileRoot = document.querySelector(MOBILE_ROOT_SELECTOR);
      if (mobileRoot && mobileRoot !== currentMobileRoot) {
        observeMobile(mobileRoot);
      }
    });
    try {
      rebindMo.observe(document.body || document.documentElement, { childList: true, subtree: true });
    } catch (e) {
    }
  }

  function init() {
    startRebindWatchdog();

    var root = document.getElementById(ROOT_ID);
    if (root) {
      observe(root);
    } else {
      var tries = 40;
      var timer = setInterval(function () {
        var r = document.getElementById(ROOT_ID);
        if (r || --tries <= 0) {
          clearInterval(timer);
          if (r) {
            observe(r);
          } else {
          }
        }
      }, 250);
    }

    var mobileRoot = document.querySelector(MOBILE_ROOT_SELECTOR);
    if (mobileRoot) {
      observeMobile(mobileRoot);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
